// extracted by mini-css-extract-plugin
export default {"create__user_modal_body":"TeacherManagement_create__user_modal_body__DMxii"};